import { backendApi } from "@/services/backend/api";
import { CpyName } from "@/services/backend/cpy/types/entity-names";

interface TextblocksCopyRequest {
  sourceEntity: string;
  sourceID: string;
  destinationEntity: string;
  destinationID: string;
  meta?: unknown;
}

const copyFromCatalogApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    textblocksCopyFromCatalog: build.mutation<void, TextblocksCopyRequest>({
      query: (request) => ({
        url: `/textblocks/copy-from-catalog`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: [
        "Textblock",
        "HtzConfirmation",
        "HtzOffer",
        "RltConfirmation",
        "RltOffer",
        "VbsConfirmation",
        "VbsOffer",
      ],
    }),
  }),
});

export const { useTextblocksCopyFromCatalogMutation } = copyFromCatalogApi;
export { CpyName };
